// extracted by mini-css-extract-plugin
module.exports = {"todayLoader":"today_todayLoader__Edpa8","fadeIn":"today_fadeIn__4hgcF","blink":"today_blink__aEPiA","dropOut":"today_dropOut__y6O1O","fadeOut":"today_fadeOut__QG_iN"};